import CategoriesItemElectronics from "./CategoriesItemElectronics.jsx";
import Footer from "../Footer.jsx";
import Newsletter from "../Newsletter.jsx";

function Electronics() {
  return (
    <>
      <CategoriesItemElectronics />
      <Newsletter />
      <Footer />
    </>
  );
}

export default Electronics;
